import React from 'react';

import { BoldText } from './AdditionalInfo.styled';

// From Nov 1, 2026 Walmart patients book through Walmart member services (KE-17527).
export const AdditionalInfoWalmart = (): JSX.Element => (
  <BoldText>
    If no appointments are available, please call Member Services at{' '}
    <a href="tel:8554547663">855-454-7663</a>.
  </BoldText>
);
